/**
 * @typedef {object} StartPayload
 *
 * @property {string} publicKey 결제키 (pk_로 시작하는 가맹점 Public Key)
 * @property {string} trxType 거래구분 0 : 등록 1 : 취소 2 : 변경
 * @property {string} trackId 가맹점 주문번호 (가맹점의 유니크한 주문번호) 중복불가
 * @property {string} identity 고객의 실명번호 생년월일 6자리 (YYMMDD) Ex) 990101 * 계좌실명인증 시 해당 실명번호로 실명조회
 * @property {string} holderName 가상계좌 수취조회 시 응답될 예금주명
 * @property {string} phoneNo 고객의 전화번호 (‘-‘ 하이픈미포함) * 본인인증받을 전화번호
 * @property {string} account 가상계좌번호 (‘-‘ 하이픈미포함) * 영구가상계좌의 경우 필수
 * @property {string} userAccountName 가상계좌 출금정보를 등록할 고객의 이름 * 실명인증 시 나온 이름과 해당 컬럼의 이름이 동일해야 하며, 입금 시에도 해당 이름과 동일한 고객이 입금해야 정상 입금된다.
 * @property {string} udf1 사용자 임의 데이터
 * @property {string} udf2 사용자 임의 데이터
 * @property {(response:ResponseData) => void} responseFunction 결제결과를javascript function으로 리턴
 * @property {string} redirectUrl 발행된 가상계좌의 정보를 url에 전달 * 사용안함 빈값(‘’)으로 설정
 * @property {string} responseType 응답형식 0 : function 1: url * ‘0’ 고정값
 */

/**
 * @typedef {object} ResponseData
 *
 * @property {object} result
 * @property {string} result.resultCd
 * @property {string} result.resultMsg
 * @property {string} result.advanceMsg
 * @property {string} result.create
 *
 * @property {object} vact
 * @property {string} vact.trackId
 * @property {string} vact.bankCd
 * @property {string} vact.account
 * @property {string} vact.holderName
 * @property {string} vact.udf1
 * @property {string} vact.udf2
 * @property {string} vact.issueId
 * @property {string} vact.mchtId
 * @property {string} vact.withdrawBankCd
 * @property {string} vact.withdrawAccount
 * @property {string} vact.phoneNo
 * @property {string} vact.authNo
 * @property {string} vact.ci
 * @property {string} vact.oneCertiInNo
 *
 * @property {string} exec
 */

/**
 * @param {StartPayload} payload
 * @returns {StartPayload}
 */
export function makeStartPayload(payload) {
    return payload;
}

export default makeStartPayload;
